export default "__VITE_ASSET__DyIrx4Iz__"